import { Nexus } from '@tomandco/nexus-api-types';
import { Option } from './option';

export abstract class OptionWithValues extends Option<number> {
    get values(): Nexus.Lib.Catalog.Type.IProductDataCustomOptionSelection[] {
        return this.data.values || [];
    }

    select(selection: Nexus.Lib.Catalog.Type.IProductDataCustomOptionSelection): void {
        this.value = selection.value;
    }

    isSelected(selection: Nexus.Lib.Catalog.Type.IProductDataCustomOptionSelection): boolean {
        return this.value === selection.value;
    }

    override sanitize() {
        if (typeof this._value === 'string') {
            this._value = Number(this._value);
        }
        if (this._value && !this.values.find(i => i.value === this._value)) {
            this._value = undefined;
        }
    }
}
